export default function getTabRouteName (tab) {
  switch (tab) {
    case 'reports': return 'LensReports'
    case 'creative-tests': return 'LensCreativeTests'
    case 'inspiration': return 'LensInspiration'
    default: return 'LensDashboardView'
  }
}